const r = new Proxy(
  {
    optimiserWslPath: ""
  },
  {
    set(t, e, o) {
      return t[e] = o, !0;
    }
  }
);
export {
  r as pyodideContext
};
